import { createSRPCClient } from "@srpc/core/client";
import type { AppRouter } from "./routes";

export const rpc = createSRPCClient<AppRouter>({
	endpoint: "/api/srpc",
});
